import {
  Button,
  Field,
  Flex,
  Heading,
  Input,
  SimpleGrid,
  Text,
} from "@chakra-ui/react";
import DropDown from "components/DropDown";
import { useState } from "react";
import { ToggleSwitch } from "components/ToggleSwitch";
import useCheckMobileScreen from "hooks/useCheckMobileScreen";
import { CardRegistration } from "components/CardRegistration";

const fs = "sm";

const AddNextContent = ({ setStatus, onSave }) => {
  const ismobile = useCheckMobileScreen();

  return (
    <>
      <SimpleGrid
        columns={ismobile ? 1 : 3}
        columnGap="2rem"
        rowGap="2rem"
        // mt="4rem"
      >
        <Field.Root orientation={"horizontal"} gap={4}>
          <Field.Label textStyle={fs}>Start Date</Field.Label>
          <Input type="date" flex="1" textStyle={fs} />
        </Field.Root>

        <Field.Root orientation={"horizontal"} gap={4}>
          <Field.Label textStyle={fs}>Vehicle Catergory</Field.Label>
          <Input type="text" flex="1" textStyle={fs} />
        </Field.Root>

        <Field.Root orientation={"horizontal"} gap={4}>
          <Field.Label textStyle={fs}>Purchase Duration</Field.Label>
          <DropDown flex="1" textStyle={fs} />
        </Field.Root>

        <Field.Root orientation={"horizontal"} gap={4}>
          <Field.Label textStyle={fs}>Purchase Claim Limit</Field.Label>
          <DropDown flex="1" textStyle={fs} />
        </Field.Root>
      </SimpleGrid>
      <Flex direction={"column"} gap={4} pt={3}>
        <Flex flexFlow={"wrap"} gap={6} mt={4}>
          <ToggleSwitch label={"DPFS"} />
          <ToggleSwitch label={"Higher Labour Rate"} />
          <ToggleSwitch label={"Wear and Tear"} />
          <ToggleSwitch label={"EGR Valves"} />
          <ToggleSwitch label={"Catalytic Converter"} />
        </Flex>
      </Flex>

      <Flex justifyContent="space-between" alignItems="center" mt={3}>
        <Text fontWeight={"bold"} textStyle={"lg"} alignSelf={"flex-end"}>
          Clear
        </Text>
        <Flex gap={4} mt={4} alignItems={"center"} ToggleSwitch>
          {/* <DialogActionTrigger asChild> */}
          <Button variant={"outline"} textStyle={fs}>
            Close
          </Button>
          {/* </DialogActionTrigger> */}
          <Button onClick={() => setStatus("add")} bg="fontdark" textStyle={fs}>
            Previous
          </Button>
          <Button onClick={() => onSave("add")} bg="primary" textStyle={fs}>
            Save
          </Button>
        </Flex>
      </Flex>
    </>
  );
};

const AddContent = ({ setStatus }) => {
  const ismobile = useCheckMobileScreen();

  return (
    <>
      <Flex direction={"column"} gap={4}>
        <Flex
          direction={ismobile ? "column" : "row"}
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          <Text fontWeight={"bold"} textStyle={fs}>
            Registration
          </Text>
          <Flex gap={8} direction={ismobile ? "column" : "row"}>
            <CardRegistration value={"RE15VNY"} />
            {/* <Flex
              overflow={"hidden"}
              borderRadius={8}
              borderWidth={2}
              borderColor={"fontdark"}
            >
              <Box bg={"blue"} p={2}>
                <Text color={"yellow"} fontWeight={"bold"} textStyle={fs}>
                  GB
                </Text>
              </Box>
              <Box bg={"yellow"} p={2} pl={6} pr={6}>
                <Text fontWeight={"bold"} textStyle={fs}>
                  RE15VNY
                </Text>
              </Box>
            </Flex> */}
            <Button bg="primary" textStyle={fs}>
              Lookup
            </Button>
          </Flex>
        </Flex>

        <SimpleGrid
          columns={ismobile ? 1 : 3}
          columnGap="2rem"
          rowGap="2rem"
          // mt="4rem"
        >
          <Field.Root orientation="horizontal" gap={4}>
            <Field.Label textStyle={fs}>Make</Field.Label>
            <Input type="text" flex="1" textStyle={fs} />
          </Field.Root>
          <Field.Root orientation="horizontal" gap={4}>
            <Field.Label textStyle={fs}>Model</Field.Label>
            <Input type="text" flex="1" textStyle={fs} />
          </Field.Root>
          <Field.Root orientation="horizontal" gap={4}>
            <Field.Label textStyle={fs}>Colour</Field.Label>
            <Input type="text" flex="1" textStyle={fs} />
          </Field.Root>
          <Field.Root orientation="horizontal" gap={4}>
            <Field.Label textStyle={fs}>Engine Capacity (CC)</Field.Label>
            <Input type="text" flex="1" textStyle={fs} />
          </Field.Root>
          <Field.Root orientation="horizontal" gap={4}>
            <Field.Label textStyle={fs}>Fuel Type</Field.Label>
            <DropDown flex="1" textStyle={fs} />
          </Field.Root>
          <Field.Root orientation="horizontal" gap={4}>
            <Field.Label textStyle={fs}>Registration Date</Field.Label>
            <Input type="date" flex="1" textStyle={fs} />
          </Field.Root>
          <Field.Root orientation="horizontal" gap={4}>
            <Field.Label textStyle={fs}>Purchase Date</Field.Label>
            <DropDown flex="1" textStyle={fs} />
          </Field.Root>
          <Field.Root orientation="horizontal" gap={4}>
            <Field.Label textStyle={fs}>Mileage</Field.Label>
            <Input type="number" flex="1" textStyle={fs} />
          </Field.Root>
        </SimpleGrid>

        {/* <Field.Root orientation={ismobile ? "vertical" : "horizontal"} gap={16}>
          <Field.Root orientation="horizontal" gap={4}>
            <Field.Label textStyle={fs}>Make</Field.Label>
            <Input type="text" flex="1" textStyle={fs} />
          </Field.Root>
          <Field.Root orientation="horizontal" gap={4}>
            <Field.Label textStyle={fs}>Model</Field.Label>
            <Input type="text" flex="1" textStyle={fs} />
          </Field.Root>
        </Field.Root> */}

        {/* <Field.Root orientation={ismobile ? "vertical" : "horizontal"} gap={16}>
          <Field.Root orientation="horizontal" gap={4}>
            <Field.Label textStyle={fs}>Colour</Field.Label>
            <Input type="text" flex="1" textStyle={fs} />
          </Field.Root>
          <Field.Root orientation="horizontal" gap={4}>
            <Field.Label textStyle={fs}>Engine Capacity (CC)</Field.Label>
            <Input type="text" flex="1" textStyle={fs} />
          </Field.Root>
        </Field.Root> */}

        {/* <Field.Root orientation={ismobile ? "vertical" : "horizontal"} gap={16}>
          <Field.Root orientation="horizontal" gap={4}>
            <Field.Label textStyle={fs}>Fuel Type</Field.Label>
            <DropDown flex="1" textStyle={fs} />
          </Field.Root>
          <Field.Root orientation="horizontal" gap={4}>
            <Field.Label textStyle={fs}>Registration Date</Field.Label>
            <Input type="date" flex="1" textStyle={fs} />
          </Field.Root>
        </Field.Root> */}

        {/* <Field.Root orientation={ismobile ? "vertical" : "horizontal"} gap={16}>
          <Field.Root orientation="horizontal" gap={4}>
            <Field.Label textStyle={fs}>Purchase Date</Field.Label>
            <DropDown flex="1" textStyle={fs} />
          </Field.Root>
          <Field.Root orientation="horizontal" gap={4}>
            <Field.Label textStyle={fs}>Mileage</Field.Label>
            <Input type="number" flex="1" textStyle={fs} />
          </Field.Root>
        </Field.Root> */}

        <Flex
          flexFlow={"wrap"}
          // orientation={ismobile ? "vertical" : "horizontal"}
          gap={6}
          mt={4}
        >
          <ToggleSwitch label={"4x4"} />
          <ToggleSwitch label={"Luxury"} />
          <ToggleSwitch label={"Specialist"} />
          {/* <Flex>
        <Field.Label textStyle={fs}></Field.Label>
        <ToggleSwitch label={"Luxury"} />
      </Flex> */}
          {/* <Field.Root orientation="horizontal" gap={4}> */}
          {/* </Field.Root> */}
        </Flex>
      </Flex>

      <Flex
        direction={ismobile ? "column" : "row"}
        justifyContent="space-between"
        alignItems="center"
        mt={3}
      >
        <Text fontWeight={"bold"} textStyle={"lg"} alignSelf={"flex-end"}>
          Clear
        </Text>
        <Flex gap={4} mt={4} alignItems={"center"} ToggleSwitch>
          <Button variant={"outline"} textStyle={"sm"}>
            Previous
          </Button>
          <Button bg="fontdark" textStyle={"sm"}>
            Lookup
          </Button>
          <Button
            onClick={() => setStatus("next")}
            bg="primary"
            textStyle={"sm"}
          >
            Next
          </Button>
        </Flex>
      </Flex>
    </>
  );
};

function CarAdd() {
  const [status, setStatus] = useState("add");

  const onSave = () => {
    // setStatus("");
  };

  return (
    <Flex flex={1} overflow={"hidden"} direction={"column"} p={"2rem"}>
      <Heading size="4xl" color="primary" mt="2.5" mb="2.5">
        {status === "next" ? "Guarantee" : "Vehicle Details"}
      </Heading>

      {status === "next" ? (
        <AddNextContent setStatus={setStatus} onSave={onSave} />
      ) : (
        <AddContent setStatus={setStatus} />
      )}

      {/* <DropDown/> */}
      {/* <Field.Root orientation="horizontal" w={'22rem'}>
              <Field.Label textStyle={"md"}>Search</Field.Label>
              <Input textStyle={"md"} />
            </Field.Root> */}

      {/* <Add /> */}
      {/* <Button variant="outline" onClick={onNew}>New</Button> */}

      {/* <TableList headers={headers} items={items} /> */}
    </Flex>
  );
}

export default CarAdd;
